/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { GetTaskStatusQueryResponse, GetTaskStatusPathParams, GetTaskStatus400, GetTaskStatus401, GetTaskStatus404, GetTaskStatus409, GetTaskStatus500 } from "../../types/GetTaskStatus.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getGetTaskStatusUrl(promptRewardID: GetTaskStatusPathParams["promptRewardID"]) {
  const res = { method: 'GET', url: `/api/prompt/${promptRewardID}/status` as const }
  return res
}

/**
 * {@link /api/prompt/:promptRewardID/status}
 */
export async function getTaskStatus(promptRewardID: GetTaskStatusPathParams["promptRewardID"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetTaskStatusQueryResponse, ResponseErrorConfig<GetTaskStatus400 | GetTaskStatus401 | GetTaskStatus404 | GetTaskStatus409 | GetTaskStatus500>, unknown>({ method : "GET", url : getGetTaskStatusUrl(promptRewardID).url.toString(), ... requestConfig })
  return res.data
}